<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="41"
    height="40"
    viewBox="0 0 41 40"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M17.9993 28.3334C12.0163 28.3334 7.16602 23.4831 7.16602 17.5C7.16602 11.5169 12.0163 6.66669 17.9993 6.66669C23.9824 6.66669 28.8327 11.5169 28.8327 17.5C28.8327 19.9909 27.992 22.2855 26.5789 24.1154L33.4259 30.9624C33.9683 31.5048 33.9683 32.3842 33.4259 32.9266C32.8835 33.469 32.0041 33.469 31.4617 32.9266L24.6147 26.0796C22.7848 27.4927 20.4902 28.3334 17.9993 28.3334ZM17.9993 25C22.1415 25 25.4993 21.6422 25.4993 17.5C25.4993 13.3579 22.1415 10 17.9993 10C13.8572 10 10.4993 13.3579 10.4993 17.5C10.4993 21.6422 13.8572 25 17.9993 25Z"
      fill="#1D1F22"
    />
    <mask
      id="mask0_2463_13180"
      style="mask-type: luminance"
      maskUnits="userSpaceOnUse"
      x="7"
      y="6"
      width="27"
      height="28"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M17.9993 28.3334C12.0163 28.3334 7.16602 23.4831 7.16602 17.5C7.16602 11.5169 12.0163 6.66669 17.9993 6.66669C23.9824 6.66669 28.8327 11.5169 28.8327 17.5C28.8327 19.9909 27.992 22.2855 26.5789 24.1154L33.4259 30.9624C33.9683 31.5048 33.9683 32.3842 33.4259 32.9266C32.8835 33.469 32.0041 33.469 31.4617 32.9266L24.6147 26.0796C22.7848 27.4927 20.4902 28.3334 17.9993 28.3334ZM17.9993 25C22.1415 25 25.4993 21.6422 25.4993 17.5C25.4993 13.3579 22.1415 10 17.9993 10C13.8572 10 10.4993 13.3579 10.4993 17.5C10.4993 21.6422 13.8572 25 17.9993 25Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_2463_13180)"></g>
  </svg>
</template>
